import "./styles.scss";
import "moment/locale/pt";
import "moment/locale/en-gb";
import "moment/locale/es";

import { API, Endpoints } from "utils/api";
import { Col, ConfigProvider, DatePicker, Drawer, Input, Row, Select, notification } from "antd";
import { UserPlaceholder, translate } from "utils/utils";
import { setBreadcrumb, setLoader, updateCrumb } from "store/actions";

import { DateTime } from "luxon";
import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";
import en from "antd/es/locale/en_GB";
import es from "antd/es/locale/es_ES";
import moment from "moment";
import pt from "antd/es/locale/pt_PT";
import { push } from "connected-react-router";

class Report extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			report: null,
			defaultDiagnostics: [],
			diagnostics: [],
			medication: false,
			startDate: null,
			locale: pt,
			clinicalDischarge: false,
			monthList: [
				moment.utc().format("MM YYYY"),
				moment.utc().add(1, "month").format("MM YYYY"),
				moment.utc().add(2, "month").format("MM YYYY"),
				moment.utc().add(3, "month").format("MM YYYY"),
				moment.utc().add(4, "month").format("MM YYYY"),
				moment.utc().add(5, "month").format("MM YYYY"),
				moment.utc().add(6, "month").format("MM YYYY")
			],
			selectedMonth: moment.utc().format("MM YYYY"),
			showDrawer: false,
			selection: [],
			slots: [],
			finalSlots: []
		};
	}

	componentDidMount() {
		const { dispatch, match } = this.props;
		const {
			params: { id }
		} = match;

		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.home,
						route: "/home"
					},
					{
						text: Strings.reports.header,
						route: `/appointments/${id}/report`
					}
				]
			}))
		);

		this.getData();
	}

	componentDidUpdate(prevProps: any) {
		const { dispatch } = this.props;
		dispatch(updateCrumb());

		if (this.props.language === "pt") {
			moment.updateLocale("pt", {
				week: {
					dow: 1 /// Date offset
				}
			});
		} else if (this.props.language === "en") {
			moment.updateLocale("en-gb", {
				week: {
					dow: 1 /// Date offset
				}
			});
		} else {
			moment.updateLocale("es-us", {
				week: {
					dow: 1 /// Date offset
				}
			});
		}

		if (this.props.language !== prevProps.language) {
			const locale = this.props.language === "pt" ? pt : this.props.language === "en" ? en : es;
			this.setState({ locale });
		}
	}

	async getData() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		await Promise.all([this.getDiagnostics(), this.getReport()]);

		dispatch(setLoader(false));
	}

	async getReport() {
		const { dispatch, match } = this.props;
		const {
			params: { id }
		} = match;

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriAppointments(`${id}/report`)
			});

			if (response?.ok) {
				const { consultation: report } = response.data.results || {};
				const { treatment } = report;

				const diagnostics = [];
				if (Array.isArray(treatment?.diagnostics)) {
					diagnostics.push(...treatment.diagnostics);
				}

				const medication = treatment?.medication || false;
				const medicationDescription = treatment?.medicationDescription || "";
				const anamnesis = treatment?.anamnesis || "";
				const goals = treatment?.goals || "";

				this.setState({ report, ...report, diagnostics, medication, medicationDescription, anamnesis, goals });
			} else if (response.status === 404) {
				notification.error({
					message: Strings.reports.header,
					description: Strings.reports.reportClosed,
					placement: "bottomRight",
					duration: 5
				});

				dispatch(push(`/home`));
			}
		} catch (err) {
			notification.error({
				message: Strings.reports.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async getDiagnostics() {
		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriSkills()
			});

			if (response.ok) {
				const { diagnosis } = response.data.results || {};
				this.setState({ defaultDiagnostics: diagnosis });
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async getSlots(loader: boolean = false) {
		const { selectedMonth } = this.state;
		const { dispatch } = this.props;

		const body: any = {
			endDate: moment.utc(selectedMonth, "MM YYYY").endOf("month").format("YYYY-MM-DD")
		};

		if (moment.utc().month() === moment.utc(selectedMonth, "MM YYYY").month()) {
			body.startDate = moment.utc().format("YYYY-MM-DD");
		} else {
			body.startDate = moment.utc(selectedMonth, "MM YYYY").startOf("month").format("YYYY-MM-DD");
		}

		if (loader) {
			dispatch(setLoader(true));
		}

		let error: any;
		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriSlots(),
				data: body
			});

			if (response.ok) {
				const { slots = [] } = response.data.results;

				const selection: Array<any> = [
					{
						month: moment.utc(selectedMonth, "MM YYYY").month(),
						year: moment.utc(selectedMonth, "MM YYYY").year(),
						days: []
					}
				];

				for (const slot of slots) {
					const newSelection = selection[0].days;
					const day = moment.utc(slot.date).date();
					if (!newSelection.includes(day)) {
						newSelection.push(day);
					}
				}

				let selectedDate: any;
				let finalSlots: Array<any> = [];
				if (slots.length) {
					selectedDate = moment.utc(slots[0].date);
					finalSlots = slots[0].slots || [];
				}

				this.setState({ selection, slots, selectedDate, finalSlots });
			} else {
				notification.error({
					message: Strings.appointments.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});

				error = response?.data?.message;
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});

			error = err as string;
		}

		if (loader) {
			dispatch(setLoader(false));
		}

		if (error) {
			return { error };
		}
	}

	disabledDate = (current: any) => {
		const { selection } = this.state;
		const available = selection.some(
			(entry: any) =>
				current.year() === entry.year && current.month() === entry.month && entry.days.includes(current.date())
		);

		return !available;
	};

	async submitAppointment() {
		const { selectedDate, selectedSlot } = this.state;

		if (!selectedDate || !selectedSlot) return;

		this.setState({ showDrawer: false, nextConsultationDate: selectedDate, nextConsultationTime: selectedSlot });
	}

	validReport() {
		const { diagnostics, goals, anamnesis, treatment } = this.state;

		if (!diagnostics?.length) {
			notification.warn({
				message: Strings.errors.invalidFields,
				description: Strings.reports.invalidDiagnostics,
				placement: "bottomRight",
				duration: 5
			});

			return false;
		}

		if (!goals) {
			notification.warn({
				message: Strings.errors.invalidFields,
				description: Strings.reports.invalidGoals,
				placement: "bottomRight",
				duration: 5
			});

			return false;
		}

		if (!treatment && !anamnesis) {
			notification.warn({
				message: Strings.errors.invalidFields,
				description: Strings.reports.invalidAnamnesis,
				placement: "bottomRight",
				duration: 5
			});

			return false;
		}

		return true;
	}

	async submitReport() {
		const {
			diagnostics,
			medication,
			medicationDescription,
			goals,
			anamnesis,
			clinicalDischarge,
			nextConsultationDate,
			nextConsultationTime,
			clinicalIntervention,
			clinicalRecord,
			clinicalNotes,
			goalsNextConsultation,
			user
		} = this.state;
		const { dispatch, match } = this.props;
		const {
			params: { id }
		} = match;

		const body = {
			diagnostics,
			medication,
			medicationDescription,
			goals,
			anamnesis,
			clinicalDischarge,
			nextConsultationDate: nextConsultationDate ? moment.utc(nextConsultationDate).format("YYYY-MM-DD") : null,
			nextConsultationTime,
			clinicalIntervention,
			clinicalRecord,
			clinicalNotes,
			goalsNextConsultation,
			externalName: user?.externalName || "",
			birthdate: user?.birthdate ? moment.utc(user.birthdate).format("YYYY-MM-DD") : null
		};

		if (!this.validReport()) {
			return;
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriAppointments(`${id}/report`),
				data: body
			});

			if (response.ok) {
				const { warningMessage } = response.data.results;
				if (warningMessage) {
					notification.warning({
						message: Strings.reports.header,
						description: translate(warningMessage),
						placement: "bottomRight",
						duration: 5
					});
				} else {
					notification.success({
						message: Strings.reports.header,
						description: Strings.reports.saved,
						placement: "bottomRight",
						duration: 5
					});
				}

				dispatch(push("/home"));
			} else {
				notification.error({
					message: Strings.reports.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.reports.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	renderUserInfo() {
		const { user, locale } = this.state;

		return (
			<div className="ReportPatientInfo">
				<div className="ReportPatientIdentifierBlock">
					<img src={user?.photo || UserPlaceholder} alt="patient avatar" />
					<h3>{user?.name || "-"}</h3>
					<p>{user?.business || "Dummy"}</p>
				</div>
				<div className="ReportPatientOther">
					<Row gutter={[0, 30]}>
						<Col xs={24}>
							<label htmlFor="patient_othername" className="InputLabel">
								{Strings.patients.otherName}
							</label>
							<Input
								id="patient_othername"
								value={user?.externalName || ""}
								className="ProfileInput"
								required
								placeholder={Strings.patients.otherName}
								onChange={(e: any) => {
									const value = e.target.value;
									this.setState((prevState: any) => ({
										user: {
											...prevState.user,
											externalName: value
										}
									}));
								}}
							/>
						</Col>
						<Col xs={24}>
							<label htmlFor="patient_birthdate" className="InputLabel">
								{Strings.patients.birthdate}
							</label>
							<ConfigProvider locale={locale}>
								<DatePicker
									id="patient_birthdate"
									suffixIcon={<Icons.Calendar date color="blue" />}
									className="ReportFullWidth"
									value={user?.birthdate ? moment.utc(user?.birthdate) : null}
									format="DD-MM-YYYY"
									monthCellRender={(currentDate: any) => {
										return currentDate.format("MMM");
									}}
									onChange={(value: any) => {
										this.setState((prevState: any) => ({
											user: {
												...prevState.user,
												birthdate: value
											}
										}));
									}}
								/>
							</ConfigProvider>
						</Col>
					</Row>
				</div>
			</div>
		);
	}

	renderDiagnostic() {
		const { defaultDiagnostics, diagnostics, medication, medicationDescription, goals, treatment, anamnesis } =
			this.state;

		return (
			<div className="ReportDiagnostic">
				<Row gutter={[50, 25]}>
					<Col xs={24}>
						<label htmlFor="report_diagnostics" className="InputLabel">
							{Strings.patients.diagnostics}
						</label>
						<Select
							id="report_diagnostics"
							className="tagsSelector ReportFullWidth"
							placeholder={Strings.patients.diagnostics}
							showSearch
							mode="multiple"
							filterOption={(input: any, option: any) =>
								option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							value={diagnostics}
							onChange={(value: any) => this.setState({ diagnostics: value })}
						>
							{defaultDiagnostics.map((tmpDiagnostic: any) => (
								<Select.Option key={`diagnostic_option_${tmpDiagnostic._id}`} value={tmpDiagnostic._id}>
									{translate(tmpDiagnostic?.name)}
								</Select.Option>
							))}
						</Select>
					</Col>
					<Col xs={24}>
						<div className="ReportMedication">
							<div>
								<label htmlFor="report_medication_bool" className="InputLabel">
									{Strings.patients.takeMeds}
								</label>
								<div id="report_medication_bool" className="ReportMedsButtons">
									<button
										className={`ReportButton${!medication && " --btn-active"}`}
										onClick={() => this.setState({ medication: false })}
									>
										{Strings.generic.no}
									</button>
									<button
										className={`ReportButton${medication && " --btn-active"}`}
										onClick={() => this.setState({ medication: true })}
									>
										{Strings.generic.yes}
									</button>
								</div>
							</div>
							<div className="ReportMedicationList">
								<label htmlFor="report_medication" className="InputLabel">
									{Strings.patients.meds}
								</label>
								<Input
									id="report_medication"
									value={medicationDescription || ""}
									className="ProfileInput"
									disabled={!medication}
									placeholder={Strings.patients.meds}
									onChange={(e: any) => {
										this.setState({
											medicationDescription: e.target.value
										});
									}}
								/>
							</div>
						</div>
					</Col>
					{!Boolean(treatment) && (
						<Col xs={24}>
							<label htmlFor="report_anamnese" className="InputLabel">
								{Strings.reports.anamnese}
							</label>
							<Input.TextArea
								id="report_anamnese"
								value={anamnesis || ""}
								className="ProfileInput"
								rows={4}
								placeholder={Strings.reports.anamnese}
								onChange={(e: any) => {
									this.setState({
										anamnesis: e.target.value
									});
								}}
							/>
						</Col>
					)}
					<Col xs={24}>
						<label htmlFor="report_treatment" className="InputLabel">
							{Strings.patients.objective}
						</label>
						<Input.TextArea
							id="report_treatment"
							value={goals || ""}
							className="ProfileInput"
							rows={6}
							placeholder={Strings.patients.objective}
							onChange={(e: any) => {
								this.setState({
									goals: e.target.value
								});
							}}
						/>
					</Col>
				</Row>
			</div>
		);
	}

	renderSpecifics() {
		const { clinicalRecord, clinicalNotes, clinicalIntervention, goalsNextConsultation } = this.state;

		return (
			<div className="ReportSpecifics">
				<Row gutter={[50, 25]}>
					<Col xs={24}>
						<label htmlFor="report_record" className="InputLabel">
							{Strings.reports.report}
						</label>
						<Input.TextArea
							id="report_record"
							value={clinicalRecord || ""}
							className="ProfileInput"
							rows={4}
							placeholder={Strings.reports.report}
							onChange={(e: any) => {
								this.setState({
									clinicalRecord: e.target.value
								});
							}}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="report_record" className="InputLabel">
							{Strings.reports.notes}
						</label>
						<Input.TextArea
							id="report_record"
							value={clinicalNotes || ""}
							className="ProfileInput"
							rows={4}
							placeholder={Strings.reports.notes}
							onChange={(e: any) => {
								this.setState({
									clinicalNotes: e.target.value
								});
							}}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="report_intervention" className="InputLabel">
							{Strings.reports.intervention}
						</label>
						<Input.TextArea
							id="report_intervention"
							value={clinicalIntervention || ""}
							className="ProfileInput"
							rows={4}
							placeholder={Strings.reports.intervention}
							onChange={(e: any) => {
								this.setState({
									clinicalIntervention: e.target.value
								});
							}}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="report_objectives" className="InputLabel">
							{Strings.reports.objectivesNextAppointment}
						</label>
						<Input.TextArea
							id="report_objectives"
							value={goalsNextConsultation || ""}
							className="ProfileInput"
							rows={4}
							placeholder={Strings.reports.objectivesNextAppointment}
							onChange={(e: any) => {
								this.setState({
									goalsNextConsultation: e.target.value
								});
							}}
						/>
					</Col>
				</Row>
			</div>
		);
	}

	renderDischarge() {
		const { startDate, clinicalDischarge, nextConsultationDate, nextConsultationTime } = this.state;
		const { language } = this.props;

		return (
			<div className="ReportDischarge">
				<Row gutter={[0, 30]}>
					<Col xs={24}>
						<label htmlFor="appointment_date" className="InputLabel">
							{Strings.reports.date}
						</label>
						<Input
							id="appointment_date"
							value={
								(startDate &&
									`${DateTime.fromISO(startDate)
										.setLocale(language)
										.toFormat("dd MMMM yyyy - HH:mm")}H`) ||
								""
							}
							className="ProfileInput"
							readOnly
							placeholder={Strings.reports.date}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="appointment_next_date" className="InputLabel">
							{Strings.reports.schedule}
						</label>
						<Input
							id="appointment_next_date"
							value={
								(Boolean(nextConsultationDate) &&
									Boolean(nextConsultationTime) &&
									`${moment
										.utc(nextConsultationDate)
										.format("DD MMMM YYYY")} - ${nextConsultationTime}H`) ||
								""
							}
							className="ProfileInput"
							readOnly
							suffix={
								<span
									onClick={async () => {
										const error = await this.getSlots(true);

										if (!error) {
											this.setState({ showDrawer: true });
										}
									}}
								>
									<Icons.Calendar color date />
								</span>
							}
							onClick={async () => {
								const error = await this.getSlots();

								if (!error) {
									this.setState({ showDrawer: true });
								}
							}}
							placeholder={Strings.reports.schedule}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="report_discharge" className="InputLabel">
							{Strings.patients.clinicalDischarge}
						</label>
						<div id="report_discharge" className="ReportMedsButtons">
							<button
								className={`ReportButton${!clinicalDischarge && " --btn-active"}`}
								onClick={() => this.setState({ clinicalDischarge: false })}
							>
								{Strings.generic.no}
							</button>
							<button
								className={`ReportButton${clinicalDischarge && " --btn-active"}`}
								onClick={() => this.setState({ clinicalDischarge: true })}
							>
								{Strings.generic.yes}
							</button>
						</div>
					</Col>
				</Row>
			</div>
		);
	}

	renderDrawerContent() {
		const { monthList, slots, selectedSlot, selectedDate, selectedMonth, selection, finalSlots, locale } =
			this.state;

		return (
			<div className="AppointmentsDrawer">
				<Row gutter={[10, 30]}>
					<Col xs={12}>
						<label htmlFor="drawer_month" className="InputLabel --label-required">
							{Strings.appointments.selectMonth}
						</label>
						<Select
							id="drawer_month"
							className="ReportFullWidth"
							placeholder={Strings.appointments.selectMonth}
							showSearch
							allowClear={false}
							filterOption={(input: any, option: any) =>
								option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							value={selectedMonth || null}
							onChange={(selectedMonth: any) =>
								this.setState({ selectedMonth }, () => this.getSlots(true))
							}
						>
							{monthList.map((month: string) => {
								let finalMonth = moment.utc(month, "MM YYYY").format("MMMM YYYY");

								return (
									<Select.Option key={`month_${month}`} value={month}>
										{`${finalMonth.substring(0, 1).toUpperCase()}${finalMonth.substring(1)}`}
									</Select.Option>
								);
							})}
						</Select>
					</Col>
					<Col xs={12}>
						<label htmlFor="drawer_day" className="InputLabel --label-required">
							{Strings.appointments.selectDate}
						</label>
						<ConfigProvider locale={locale}>
							<DatePicker
								id="drawer_day"
								dropdownClassName="AppointmentsDatePicker"
								className="ReportFullWidth"
								disabledDate={this.disabledDate}
								disabled={!selection.length}
								suffixIcon={<Icons.Calendar date color="blue" />}
								allowClear={false}
								value={selectedDate || null}
								onChange={(value: any) => {
									const slot = slots.find(
										(tmpSlot: any) => moment.utc(tmpSlot.date).date() === value.date()
									);
									this.setState({ selectedDate: value, finalSlots: slot.slots });
								}}
							/>
						</ConfigProvider>
					</Col>
					<Col xs={24}>
						<label htmlFor="drawer_slots" className="InputLabel --label-required">
							{Strings.appointments.availableSlots}
						</label>
						<div className="DrawerSlots">
							{finalSlots.map((slot: number, index: number) => {
								return (
									<button
										key={`slot_${slot}_${index}`}
										className={`DrawerSlot${selectedSlot === slot ? " --slot-selected" : ""}`}
										onClick={() =>
											this.setState({
												selectedSlot: slot
											})
										}
									>
										<p>{slot}</p>
									</button>
								);
							})}
							{finalSlots.length === 0 && <p>{Strings.appointments.noSlots}</p>}
						</div>
					</Col>
				</Row>
			</div>
		);
	}

	renderDrawer() {
		const { showDrawer } = this.state;
		const { mobile } = this.props;

		return (
			<Drawer
				title={<h2 className="DrawerTitle">{Strings.appointments.schedule}</h2>}
				footer={
					<div className="DrawerFooter">
						<button
							className="DrawerFooterButton"
							onClick={() =>
								this.setState({
									tempAppointment: null,
									submitType: null,
									showDrawer: false
								})
							}
						>
							{Strings.appointments.cancel}
						</button>
						<button className="DrawerFooterButton --btn-primary" onClick={() => this.submitAppointment()}>
							{Strings.appointments.confirm}
						</button>
					</div>
				}
				className="drawer"
				width={mobile ? "100%" : 400}
				placement="right"
				closable={true}
				visible={showDrawer}
				onClose={() => this.setState({ showDrawer: false })}
			>
				{this.renderDrawerContent()}
			</Drawer>
		);
	}

	render() {
		const { mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.reports.header} | Team24</title>
					<meta name="description" content="Description of Report" />
				</Helmet>
				<div className="ReportContent">
					<h1 className="GenericTitle">{Strings.reports.header}</h1>
					<div className="ReportPatientBlock">
						{this.renderUserInfo()}
						<div className="ReportPatientSeparator" />
						{this.renderDiagnostic()}
					</div>
					<div className="ReportPatientBlock">
						{this.renderSpecifics()}
						<div className="ReportPatientSeparator" />
						{this.renderDischarge()}
					</div>
					<button className="SubmitReport" onClick={() => this.submitReport()}>
						{Strings.reports.save}
					</button>
				</div>
				{this.renderDrawer()}
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	mobile: state.mobile
});

export default connect(mapStateToProps)(Report);
